export default function RateStrip() {
  return (
    <div className="rate-strip" data-testid="rate-strip">
      <p>
        RATES CHANGE DAILY. MESSAGE US WITH YOUR SECTION AND QUANTITY — WE
        REPLY WITHIN THE HOUR.
      </p>
    </div>
  );
}
